import {
  Route,
  Routes,
  Navigate,
  BrowserRouter,
  Outlet
} from "react-router-dom";

// --| Styles
import "./styles/App.css";
import "./styles/color.css";
import "./pages/auth/auth.css";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { ToastContainer } from "react-toastify";
import themes from "./themes";

import Error from "./pages/error/Error";
import InternalServer from "./pages/error/InternalServer";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import StudentEnrol from "./pages/studentenrolment";
import UserSignUp from "./pages/auth/user/Signup";
import StudentSignUp from "./pages/auth/student/Signup";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import AuthVerification from "./pages/auth/AuthVerification";
import AdminClassDetails from "./pages/classes/admin/ClassDetails";
import Classes from "./pages/classes/index";
import UserClasses from "./pages/classes/user/EmployeeAllClasses";
import StudentInfo from "./pages/classes/user/StudentInfo";
import Examination from "./pages/examination/index";
import Student from "./pages/student/Student";
import ExamPaperReview from "./pages/examination/employer/ExamPaperReview";
import EmployeeExamReview from "./pages/examination/employee/EmployeeExamPaperReview";
import Inventory from "./pages/inventory/Inventory";
import Guardian from "./pages/guardian/Guardian";
import GuardianDetail from "./pages/guardian/GuardianDetail";
import ChildTimeTable from "./pages/guardian/components/Timetable";
import EditInventory from "./pages/inventory/EditInventory";
import ArchivedInventory from "./pages/inventory/ArchivedInventory";
import CreateInventory from "./pages/inventory/CreateInventory";
import LeaveMgt from "./pages/leavemgt/LeaveMgt";
import LeaveMgtDetails from "./pages/leavemgt/LeaveMgtDetails";
import LeaveOption from "./pages/leavemgt/LeaveOptions";
import LeaveOptionDetails from "./pages/leavemgt/LeaveOptionDetails";
import Integration from "./pages/integration";
import WelcomeToShelf from "./pages/onboarding/WelcomeToShelf";
import OnboardingGuide from "./pages/onboardingpage/index";
import PerfEval from "./pages/perfeval/PervEval";
import GoalCategory from "./pages/perfeval/GoalCategory";
import Procurement from "./pages/procurement/Procurement";
import Contractors from "./pages/procurement/Contractors";
import ProcurementMenu from "./pages/procurement/procurementmenu";
import SchoolPlans from "./pages/schoolplans/index";
import SchoolSession from "./pages/schoolplans/Employer/SchoolSession";
import SchoolTerm from "./pages/schoolplans/Employer/SchoolTerm";
import EmployeeSchCalendar from "./pages/schoolplans/Employee/EmployeeSchoolCalendar";
import ViewSchoolPlans from "./pages/schoolplans/Employer/ViewSchoolPlans";
import SchoolCalendar from "./pages/schoolplans/Employer/SchoolCalendar";
import Resources from "./pages/resources/Resources";
import Resource from "./pages/resources/Resource";
import ResourceLabel from "./pages/resources/ResourceLabel";
import Settings from "./pages/settings/index";
// import ApiUsage from "./pages/settings/components/ApiUsage";
import Subjects from "./pages/subjects/index";
import EmployeeSubjects from "./pages/subjects/employee/EmployeeSubject";
import AdminAssignment from "./pages/assignment/Index";
import AssignmentDetail from "./pages/assignment/components/AssignmentDetail";
import StudentAssignmentDetail from "./pages/assignment/components/StudentAssignmentDetail";
import AssignmentSubmission from "./pages/assignment/admin/AssignmentSubmission";
// import Assignments from "./pages/subjects/components/ForEmployee/Assignments";
import Employees from "./pages/employees";
import Employee from "./pages/employees/EmployeeDetail";
import Enrolments from "./pages/enrolments";
import Applications from "./pages/enrolments/Applications";
import Welfare from "./pages/welfare/Welfare";
import Dashboard from "./pages/dashboard/Dashboard";
import Profile from "./pages/profile/index";
import CreateClass from "./pages/classes/admin/AllClasses";
import ClassesCalendar from "./pages/classes/admin/AllClassesCalendar";
import InventoryCategory from "./pages/inventory/InventoryCategory";
import Permission from "./pages/error/Permission";
import Events from "./pages/events/index";
import EventDetails from "./pages/events/admin/EventDetails";
import SitemMap from "./pages/sitemap/SiteMap";
import AccessActivities from "./pages/acesscontrol/index";
import AccessCodes from "./pages/acesscontrol/admin/AccessCodes";
import ValidateCode from "./pages/acesscontrol/component/ValidateCode";
import AccessInfo from "./pages/acesscontrol/component/AccessInfo";
import Library from "./pages/library/index";
import NotificationDetails from "./pages/notification/NotificationDetails";
import AllNotification from "./pages/notification/AllNotification";
import StudentApplication from "./pages/studentapplication/Studentoverview";
import LessonNote from "./pages/lessonnote/index";
import ViewLessonNote from "./pages/lessonnote/component/ViewLessonNote";
import ViewSubjectNote from "./pages/lessonnote/component/ViewSubjectLessonNote";
import CreateLessonNote from "./pages/lessonnote/component/CreateLessonNote";
import EditLessonNote from "./pages/lessonnote/component/EditLessonNote";
import LessonNoteDraft from "./pages/lessonnote/component/LessonNoteDraft";
import LessonNoteCustomField from "./pages/lessonnote/admin/LessonNoteCustomField";
import Attendance from "./pages/attendance/index";
import EmployeeLeaveCalendar from "./pages/leavemgt/components/EmployeeLeaveCalendar";
import SubjectDetails from "./pages/subjects/student/component/SubjectDetails";
import StudentSyllabus from "./pages/syllabus/index";
import SyllabusDetails from "./pages/syllabus/student/component/SyllabusDetails";
import AdminCalendar from "./pages/leavemgt/components/AdminCalendar";
import LeaveCalendar from "./pages/welfare/components/LeaveCalendar";
import TimeTable from "./pages/timetable/index";
import ViewEnrolment from "./pages/enrolments/ViewEnrolment";
import AdminTimeTableCalendar from "./pages/timetable/admin/component/TimeTableCalendar";
// import SubjectTimeTable from "./pages/timetable/admin/component/SubjectTimeTableInfo";
import EditTimeTable from "./pages/timetable/admin/component/EditTimeTable";
import ViewLibraryItem from "./pages/library/component/ViewLibraryBook";
import AdminNoticeBoard from "./pages/noticeboard/admin/AdminNoticeBoard";
import EditAssignment from "./pages/assignment/components/EditAssignment";
import GradingSystem from "./pages/examination/employer/component/GradingSystem";
import StudentExam from "./pages/studentexam";
import StudentEnrolExam from "./pages/studentexam/student/Examination";
import AdminPaymentOverview from "./pages/payment/index";
import InvoiceItem from "./pages/payment/admin/InvoiceItem";
import PaymentInvoice from "./pages/payment/admin/Invoice";
import CreateInvoice from "./pages/payment/admin/component/CreateInvoice";
import PreviewInvoice from "./pages/payment/admin/component/PreviewInvoice";
import StudentPreview from "./pages/payment/student/MyInvoiceOverview";
import PreviewPayInvoice from "./pages/payment/admin/component/PayInvoice";
import EditInvoice from "./pages/payment/admin/component/EditInvoice";
import PaymentDeclined from "./pages/payment/admin/component/PaymentDeclined";
import Support from "./pages/support/index";
import CreateTicket from "./pages/support/components/CreateTicket";
import ViewTicket from "./pages/support/components/ViewTicket";
import AdminCA from "./pages/test/admin/AdminCA";
import CreateCA from "./pages/test/components/CreateCA";
import TestAudit from "./pages/test/components/TestAudit";
import TestResults from "./pages/test/components/TestResults";
import EditCA from "./pages/test/components/EditCA";
import TestDetail from "./pages/test/components/TestDetail";
import StudentTest from "./pages/test/student/StudentTest";
import EnrolTest from "./pages/test/components/EnrolTest";
import ObtainableScore from "./pages/test/components/ObtainableScore";
import StudentTestResult from "./pages/test/student/StudentTestResults";
import StudentEnrolAssignment from "./pages/assignment/components/EnrolAssignment";
import InvoiceDetails from "./pages/payment/admin/component/InvoiceDetailsPage";
import Discount from "./pages/payment/admin/Discount";
import PaymentHistory from "./pages/payment/admin/InvoiceAudit";
import PaymentHistoryReview from "./pages/payment/admin/component/PaymentReview";
import TransactionHistory from "./pages/payment/admin/component/TransactionHistory";
import StudentList from "./pages/payment/admin/StudentList";
import AstudentList from "./pages/payment/admin/component/AstudentDetail";

import CAResultDetail from "./pages/test/components/CAResultDetail";
import ExaminationResultDetail from "./pages/examination/employer/component/ExaminationResultDetail";
import AssignmentResultDetail from "./pages/assignment/components/AssignmentResultDetail";

// context
import { useUserState } from "./context/UserContext";
import PurchaseOrder from "./pages/procurement/PurchaseOrder";
// import Enrolments from "./pages/studentapplications/Enrolments";
import EnrolmentDetails from "./pages/enrolments/EnrolmentsDetails";
import ControlCenter from "./pages/acesscontrol/admin/ControlCenter";
import ApplicantLogin from "./pages/studentapplication/ApplicantLogin";
import EntranceExamination from "./pages/studentapplication/entranceexamination/EntranceExamination";
import ClassCalendar from "./pages/classes/components/ClassCalendar";
import Assessments from "./pages/assessment/Index";
import CreateEnrolments from "./pages/enrolments/CreateEnrolments";
import Success from "./pages/studentenrolment/Success";
import PaymentSuccess from "./pages/payment/admin/component/PaymentSuccess";
import Failed from "./pages/studentenrolment/Failed";
import Enrolmentpreview from "./pages/enrolments/Enrolmentpreview";
import ApplicationDetails from "./pages/enrolments/ApplicationDetails";
import EditEnrolment from "./pages/enrolments/EditEnrolment";
import RolesandPermissions from "./pages/settings/components/RolesandPermission";
import UpdateRole from "./pages/settings/components/UpdateRole";
import EmployeeNotice from "./pages/noticeboard/employee/EmployeeNotice";
import StudentNoticeBoard from "./pages/noticeboard/student/StudentNoticeBoard";
import ExamCalendar from "./pages/scheduleexam/component/ExamCalendar";
import EmployeeExamination from "./pages/examination/employee/EmployeeExamination";
import EnrolmentExam from "./pages/enrolmentexam";
import EditEnrolmentExam from "./pages/enrolmentexam/admin/component/EditEnrolmentExam";
import EnrolmentExamDetails from "./pages/enrolmentexam/admin/component/EnrolmentExaminationDetails";
import CreateEnrolmentExam from "./pages/enrolmentexam/admin/component/CreateEnrolmentExam";
import CreateExam from "./pages/examination/employer/component/CreateExam";
import ExamPeriod from "./pages/scheduleexam/admin/ScheduleExam";
import EditSchoolExam from "./pages/examination/employer/component/EditSchoolExam";
import SchoolExamDetails from "./pages/examination/employer/component/SchoolExamDetails";
import BroadSheet from "./pages/examination/employer/component/Broadsheet";
import QuestionBank from "./pages/examination/employer/component/QuestionBank";
import SchoolQuestionBank from "./pages/examination/employer/component/SchoolQuestionBank";
import EmployerSubject from "./pages/subjects/employer/SubjectDetails";
import SubjectResultDetails from "./pages/subjects/employer/SubjectResultDetails";
import AllSubjectResultDetails from "./pages/subjects/employer/AllSubjectDetails";
import EmployerSyllabusDetails from "./pages/syllabus/employer/EmployerSyllabusDetails";
import SyllabusEditor from "./pages/syllabus/employer/SyllabusEditor";
import SyllabusTopicDetails from "./pages/syllabus/employer/SyllabusTopicDetails";
import StudentSyllabusTopicDetails from "./pages/syllabus/student/component/SyllabusTopicDetails";
import EmployeeSyllabusDetails from "./pages/syllabus/employee/EmployeeSyllabusDetails";
import SharedSyllabusList from "./pages/syllabus/components/SharedSyllabusList";
import StudentAssignment from "./pages/assignment/student/StudentAssignment";
import AdminCreateAssignent from "./pages/assignment/components/AdminCreateAssignment";
import EmailSubscription from "./pages/messaging/EmailSubscription";
import EmailSubscriber from "./pages/messaging/EmailSubriber";
import SubscriberDetails from "./pages/messaging/components/SubcriberDetails";
import BulkEmail from "./pages/messaging/BulkEmail";
import EmailTemplate from "./pages/messaging/emailTemplate";
import SendBulkEmail from "./pages/messaging/components/SendBulkEmail";
import MailingSettings from "./pages/messaging/MailingSettings";
import LessonNoteReview from "./pages/lessonnotereview/index";
import ViewNoteReviewNote from "./pages/lessonnotereview/component/ViewSubjectLessonNote";
import EmployeeAssignment from "./pages/assignment/user/EmployeeAssignment";
import AssignGuardian from "./pages/guardian/components/AssignGuardian";
import ViewInventory from "./pages/inventory/ViewInventory";
import ReportBroadsheet from "./pages/Reports/Admin/ReportBroadsheet";
import Reports from "./pages/Reports/Admin/Reports";
import TeachersReportBroadsheet from "./pages/Reports/Teachers/ReportBroadsheet";
import TeachersReports from "./pages/Reports/Teachers/Reports";
import EditReport from "./pages/Reports/component/EditReport";
import ViewReport from "./pages/Reports/component/ViewReport";
import ReportTemplate from "./pages/Reports/Admin/ReportTemplate";
import ManageTemplate from "./pages/Reports/component/ManageTemplate";
import BatchImportGuardian from "./pages/guardian/components/BatchImportGuardian";
import SessionReport from "./pages/Reports/Admin/SessionReport";
import ViewSessionClass from "./pages/Reports/component/ViewSessionClass";
import Promotion from "./pages/Reports/Admin/Promotion";
import ClassPromotion from "./pages/Reports/component/ClassPromotion";
import SessionBroadsheet from "./pages/Reports/Admin/SessionBroadsheet";
import StudentSessionReport from "./pages/Reports/component/StudentSessionReport";
import GuardianPassword from "./pages/password/GuardianPassword";
import StudentPassword from "./pages/password/StudentPassword";
import StudentLeave from "./pages/leavemgt/StudentLeave";
import StudentLeaveDetails from "./pages/leavemgt/StudentLeaveDetails";
import HostelManagement from "./pages/hostel/index";
import HostelDetails from "./pages/hostel/component/HostelInfo";
import RoomDetail from "./pages/hostel/component/RoomDetail";
import HostelMessages from "./pages/hostel/component/HostelMessage";
import HostelInventory from "./pages/hostel/component/HostelInventory";
import StudentMessages from "./pages/hostel/student/HostelMessage";
import PromotionClass from "./pages/Reports/Admin/PromotionClass";
import CustomReport from "./pages/Reports/Admin/CustomReport";
import CreateCustomReport from "./pages/Reports/component/CreateCustomReport";
import ViewCustomReport from "./pages/Reports/component/ViewCustomReport";
import ViewClassCustom from "./pages/Reports/component/ViewClassCustom";
import CreateStudent from "./pages/student/CreateStudent";
import AuditTrail from "./pages/audittrail/index";
import ConfigPage from "./pages/settings/components/ConfigPage";
import EmployeesPassword from "./pages/password/EmployeesPassword";
import GuardianTimetable from "./pages/timetable/guardian/GuardianTimetable";
import GuardianSubject from "./pages/subjects/guardian/Guardian";
import GuardianAttendance from "./pages/attendance/guardian/GuardianAttendance";
import GuardiaAssignment from "./pages/assignment/guardian/GuardianAssignment";
import GuardianAssessments from "./pages/assessment/guardian/index";
import GuardianNotification from "./pages/noticeboard/guardian/index";
import GuardianPayment from "./pages/payment/guardian/index";
import GuardianPreview from "./pages/payment/guardian/MyInvoiceOverview";
import GuardianReceipt from "./pages/payment/guardian/Receipt";
import TransactionDetails from "./pages/payment/guardian/TransactionDetails";
import SubscriptionInvoice from "./pages/settings/components/Invoice";
import AccountSelect from "./pages/auth/AccountSelect";
import GenerateLink from "./pages/referral/GenerateLink";
import ReferralSuccess from "./pages/referral/ReferralSuccess";
import ReferralAuth from "./pages/referral/ReferralAuth";
import ReferralDashboard from "./pages/referral/ReferralDashboard";
import Wallet from "./pages/wallet";
import MyBank from "./pages/wallet/MyBank";
import StudentReward from "./pages/reward/StudentReward";
import MyLearning from "./pages/mylearning/index";
import PracticeQuiz from "./pages/mylearning/PracticeQuiz";
import ReviewQuiz from "./pages/mylearning/ReviewQuiz";

const App = () => {
  const { isAuthenticated, appColor } = useUserState();
  const theme = appColor ? themes(appColor) : themes("#0065FF");

  const AuthenticatedRoute = () => {
    return isAuthenticated ? <Outlet /> : <Navigate to="/auth/login" />;
  };

  return (
    <div className="App">
      <ThemeProvider theme={theme.default}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            {/* This Redirect root URL based on authentication */}
            <Route
              path="/"
              element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/auth/login" />}
            />
            {/* Authenticated Routes */}
            <Route path="/" element={<AuthenticatedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/wallet/my-bank" element={<MyBank />} />
              <Route path="/student/reward" element={<StudentReward />} />
              <Route path="/student/my-learning" element={<MyLearning />} />
              <Route path="/student/my-learning/practice/:sessionId" element={<PracticeQuiz />} />
              <Route path="/student/my-learning/practice-review/:sessionId" element={<ReviewQuiz />} />
              <Route path="/school-plans" element={<SchoolPlans />} />
              <Route
                path="/assesments/student/grades"
                element={<Assessments />}
              />
              <Route path="/class-activities/classes" element={<Classes />} />
              <Route
                path="/class-activities/classes/:id"
                element={<AdminClassDetails />}
              />
              <Route
                path="/hostel"
                element={<HostelManagement />}
              />
              <Route
                path="/hostel/:id"
                element={<HostelDetails />}
              />
              <Route
                path="/hostel/inventory/:id"
                element={<HostelInventory />}
              />
              <Route
                path="/room-detail/:id"
                element={<RoomDetail />}
              />
              <Route
                path="/hostel/messages/:id"
                element={<HostelMessages />}
              />
              <Route
                path="/hostel/my-messages"
                element={<StudentMessages />}
              />
              <Route
                path="/class-activities/classes/createclass"
                element={<CreateClass />}
              />
              <Route path="/myclasses" element={<UserClasses />} />
              <Route
                path="/class-activities/classes/calendar"
                element={<ClassesCalendar />}
              />
              {/* <Route
                path="/class-activities/classes/createclass/allclasses"
                element={<EmployeeAllClasses />}
              /> */}
              <Route
                path="/class-activities/classes/students/:id"
                element={<StudentInfo />}
              />
              <Route
                path="/class-activities/classes/class-calendar"
                element={<ClassCalendar />}
              />
              {/* <Route path="/trash" element={<SchoolTrash />} /> */}
              <Route path="/examinations" element={<EmployeeExamination />} />
              <Route path="/school-examination/examination" element={<Examination />} />
              <Route path="/school-examination/broadsheet" element={<BroadSheet />} />
              <Route path="/report/grade-system" element={<GradingSystem />} />
              <Route path="/subjects/subject-result/:id" element={<SubjectResultDetails />} />
              <Route path="/subjects/all-subject-result/:id" element={<AllSubjectResultDetails />} />
              <Route path="/class-activities/employer/syllabus/:id" element={<EmployerSyllabusDetails />} />
              <Route path="/class-activities/employer/syllabus/:subjectId/:syllabusId" element={<SyllabusEditor />} />
              <Route path="/class-activities/employer/syllabus/:subjectId/:syllabusId/topics/:topicId" element={<SyllabusTopicDetails />} />
              <Route path="/class-activities/student/syllabus/:subjectId/:syllabusId/topics/:topicId" element={<StudentSyllabusTopicDetails />} />
              <Route path="/class-activities/employee/syllabus/:id" element={<SharedSyllabusList />} />
              <Route path="/class-activities/employee/syllabus/:subjectId/:syllabusId" element={<EmployeeSyllabusDetails />} />
              <Route path="/class-activities/employee/syllabus/:subjectId/:syllabusId/topics/:topicId" element={<SyllabusTopicDetails />} />
              <Route path="/school-examination/edit-examination/:id" element={<EditSchoolExam />} />
              <Route path="/school-examination/examination-details/:id" element={<SchoolExamDetails />} />
              <Route path="/school-examination/schedule-examination/:id" element={<ExamCalendar />} />
              <Route path="/school-examination/create-examination" element={<CreateExam />} />
              <Route path="/school-examination/question-bank" element={<QuestionBank />} />
              <Route path="/school-examination/school-question-bank" element={<SchoolQuestionBank />} />
              {/* <Route path="/enrolments/enrolment-examination" element={<EnrolmentExam />} /> */}
              <Route path="/enrolments/create-enrolment-examination" element={<CreateEnrolmentExam />} />
              <Route path="/enrolments/enrolment-examination" element={<EnrolmentExam />} />
              <Route path="/enrolments/edit-enrolment-examination/:id" element={<EditEnrolmentExam />} />
              <Route path="/enrolments/enrolment-examination-details/:id" element={<EnrolmentExamDetails />} />
              {/* <Route path="/enrolments/create-enrolment-examination" element={<CreateEnrolment />} /> */}
              <Route
                path="/assesments/examination/jssone-examination-papers/exam-paper-review"
                element={<ExamPaperReview />}
              />
              <Route
                path="/assesments/examination/jssone-examination-papers/employee-exam-paper-review"
                element={<EmployeeExamReview />}
              />
              <Route
                path="/notifications/:id"
                element={<NotificationDetails />}
              />
              <Route path="/notifications" element={<AllNotification />} />
              <Route path="/users/students" element={<Student />} />
              <Route path="/users/create-student" element={<CreateStudent />} />
              <Route path="/users/students/:id" element={<StudentInfo />} />
              <Route path="/users/guardians" element={<Guardian />} />
              <Route path="/users/assign-guardian" element={<AssignGuardian />} />
              <Route path="/users/batch-import-guardian" element={<BatchImportGuardian />} />
              <Route path="/users/guardians/:id" element={<GuardianDetail />} />
              <Route
                path="/users/guardians/child-timetable"
                element={<ChildTimeTable />}
              />
              <Route path="/assessment" element={<AdminCA />} />
              <Route path="/edit-assessment/:id" element={<EditCA />} />
              <Route path="/assessment-detail/:id" element={<TestDetail />} />
              <Route path="/create-assessment" element={<CreateCA />} />
              <Route path="/assessment-audits" element={<TestAudit />} />
              <Route path="/assessment-results" element={<TestResults />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/inventory/:id" element={<EditInventory />} />
              <Route path="/inventory/view-inventory/:id" element={<ViewInventory />} />
              <Route
                path="/inventory/create"
                element={<CreateInventory />}
              />
              <Route
                path="/inventory/categories"
                element={<InventoryCategory />}
              />
              <Route
                path="/inventory/archive-inventory"
                element={<ArchivedInventory />}
              />
              <Route path="/manage/leave" element={<LeaveMgt />} />
              <Route path="/enrolments" element={<Enrolments />} />
              <Route path="/enrolments/:id" element={<EnrolmentDetails />} />
              <Route
                path="/enrolments/applications"
                element={<Applications />}
              />
              <Route path="/enrolments/create" element={<CreateEnrolments />} />
              <Route
                path="/enrolments/viewenrolments"
                element={<ViewEnrolment />}
              />
              {/* <Route path="/applications/enrolments" element={<Enrolments />} /> */}
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/manage/leave/:id" element={<LeaveMgtDetails />} />
              <Route path="/manage/student-leave-details/:id" element={<StudentLeaveDetails />} />
              <Route
                path="/manage/leave/team-calendar"
                element={<AdminCalendar />}
              />
              <Route
                path="/manage/student-leave"
                element={<StudentLeave />}
              />
              <Route
                path="/manage/leave/leave-calendar/:id"
                element={<EmployeeLeaveCalendar />}
              />
              <Route path="/manage/leaveoptions" element={<LeaveOption />} />
              <Route
                path="/manage/leaveoptions/:id"
                element={<LeaveOptionDetails />}
              />
              <Route path="/payment-settings" element={<Integration />} />
              <Route path="/users/employees" element={<Employees />} />
              <Route path="/users/employees/:id" element={<Employee />} />
              <Route path="/welfare" element={<Welfare />} />
              <Route path="/leave/team-calendar" element={<LeaveCalendar />} />
              <Route path="/library" element={<Library />} />
              <Route path="/library/:id" element={<ViewLibraryItem />} />
              <Route path="/time-table" element={<TimeTable />} />
              <Route
                path="/time-table/subject-timetable"
                element={<EditTimeTable />}
              />
              <Route
                path="/timetable/admin-calendar"
                element={<AdminTimeTableCalendar />}
              />
              <Route path="/lesson-notes" element={<LessonNote />} />
              <Route path="/lesson-notes/custom-fields" element={<LessonNoteCustomField />} />
              <Route path="/lesson-notes/:id" element={<ViewLessonNote />} />
              <Route
                path="/lesson-notes/:id/create-lesson-outline"
                element={<CreateLessonNote />}
              />
              <Route
                path="/lesson-notes/edit-lesson-outline/:id"
                element={<EditLessonNote />}
              />
              <Route
                path="/lesson-notes/lesson-outlines/:id"
                element={<ViewSubjectNote />}
              />
              <Route
                path="/lesson-notes/drafts/:id"
                element={<LessonNoteDraft />}
              />
              <Route path="/lesson-notes-review" element={<LessonNoteReview />} />
              <Route path="/lesson-notes-review/:id" element={<ViewNoteReviewNote />} />

              <Route
                path="/accesscontrol/logs"
                element={<AccessActivities />}
              />
              <Route path="/accesscontrol/codes" element={<AccessCodes />} />
              <Route
                path="/accesscontrol/validate"
                element={<ValidateCode />}
              />
              <Route
                path="/accesscontrol/codes/create"
                element={<ControlCenter />}
              />
              <Route path="/guardians/password/:id" element={<GuardianPassword />} />
              <Route path="/employees/password/:id" element={<EmployeesPassword />} />
              <Route path="/students/password/:id" element={<StudentPassword />} />
              <Route path="/accesscontrol/codes/:id" element={<AccessInfo />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:id" element={<EventDetails />} />
              <Route path="/manage/goals" element={<PerfEval />} />
              <Route path="/site-map" element={<SitemMap />} />
              <Route path="/payment/overview" element={<AdminPaymentOverview />} />
              <Route path="/payment/invoice-item" element={<InvoiceItem />} />
              <Route path="/payment/discount" element={<Discount />} />
              <Route path="/payment/payment-history/:id" element={<PaymentHistoryReview />} />
              <Route path="/payment/payment-history" element={<PaymentHistory />} />
              <Route path="/payment/transaction-history" element={<TransactionHistory />} />
              <Route path="/payment/student-list" element={<StudentList />} />
              <Route path="/payment/create-invoice" element={<CreateInvoice />} />
              <Route path="/payment/edit-invoice/:id" element={<EditInvoice />} />
              <Route path="/payment/invoice" element={<PaymentInvoice />} />
              <Route path="/payment/preview-invoice/:id" element={<PreviewInvoice />} />
              <Route path="/payment/invoice-details/:id" element={<InvoiceDetails />} />
              <Route path="/payment/student-list-detail/:id" element={<AstudentList />} />
              <Route path="/payment/my-invoice/:id" element={<StudentPreview />} />
              <Route path="/manage/notice-board" element={<AdminNoticeBoard />} />
              <Route path="/student/notice-board" element={<StudentNoticeBoard />} />
              <Route path="/manage/goal-category" element={<GoalCategory />} />
              <Route path="/manage/procurements" element={<Procurement />} />
              <Route path="/employee/notice-board" element={<EmployeeNotice />} />
              <Route path="/support/tickets" element={<Support />} />
              <Route path="/support/open-ticket" element={<CreateTicket />} />
              <Route path="/support/ticket/:id" element={<ViewTicket />} />
              <Route path="/obtainable-score" element={<ObtainableScore />} />
              <Route path="/audit-trail" element={<AuditTrail />} />
              <Route
                path="/manage/procurements/new"
                element={<PurchaseOrder />}
              />
              <Route
                path="/manage/procurements/contractors"
                element={<Contractors />}
              />
              <Route
                path="/manage/procurements/ProcurementMenu"
                element={<ProcurementMenu />}
              />
              <Route
                path="/report/broadsheet"
                element={<ReportBroadsheet />}
              />
              <Route
                path="/report/promotion"
                element={<Promotion />}
              />
              <Route
                path="/report/viewpromotion"
                element={<ClassPromotion />}
              />
              <Route
                path="/report/reports"
                element={<Reports />}
              />
              <Route
                path="/report/session"
                element={<SessionReport />}
              />
              <Route
                path="/report/custom"
                element={<CustomReport />}
              />
              <Route
                path="/report/custom/view/:id"
                element={<ViewCustomReport />}
              />
              <Route
                path="/report/custom/view/:id/:studentid"
                element={<ViewCustomReport />}
              />
              <Route
                path="/report/custom/class/:id"
                element={<ViewClassCustom />}
              />
              <Route
                path="/report/custom/create"
                element={<CreateCustomReport />}
              />
              <Route
                path="/report/sessionreport"
                element={<ViewSessionClass />}
              />
              <Route
                path="/report/template"
                element={<ReportTemplate />}
              />
              <Route
                path="/report/managetemplate"
                element={<ManageTemplate />}
              />
              <Route
                path="/report/editreport/:id"
                element={<EditReport />}
              />
              <Route
                path="/report/editreport/student/:id"
                element={<EditReport />}
              />
              <Route
                path="/report/viewreport/:id"
                element={<ViewReport />}
              />
              <Route
                path="/report/viewreport/student/:id"
                element={<ViewReport />}
              />
              <Route
                path="/reports/broadsheet"
                element={<TeachersReportBroadsheet />}
              />
              <Route
                path="/reports/sessionbroadsheet/:id"
                element={<SessionBroadsheet />}
              />
              <Route
                path="/reports/studentreport/:id"
                element={<StudentSessionReport />}
              />
              <Route
                path="/reports/reports"
                element={<TeachersReports />}
              />
              <Route
                path="/report/sessionreport/:id"
                element={<ViewSessionClass />}
              />
              <Route
                path="/report/promotion/:id"
                element={<PromotionClass />}
              />
              <Route path="/schoolplans" element={<SchoolPlans />} />
              <Route path="/schoolsession" element={<SchoolSession />} />
              <Route path="/schoolterm" element={<SchoolTerm />} />
              <Route
                path="/schoolplans/employee-school-plan"
                element={<EmployeeSchCalendar />}
              />
              <Route
                path="/schoolplans/view-school-plans"
                element={<ViewSchoolPlans />}
              />
              <Route
                path="/schoolplans/view-school-plans/school-calender"
                element={<SchoolCalendar />}
              />
              <Route path="/manage/knowledgebase" element={<Resources />} />
              <Route path="/manage/knowledgebase/:id" element={<Resource />} />
              <Route
                path="/manage/knowledgebase/labels"
                element={<ResourceLabel />}
              />
              <Route path="/settings" element={<Settings />} />
              {/* <Route path="/settings/:id" element={<ApiUsage />} /> */}
              <Route
                path="/assignments"
                element={<AdminAssignment />}
              />
              <Route
                path="/my-assignments"
                element={<EmployeeAssignment />}
              />
              <Route path="/assesments/assignments" element={<StudentAssignment />} />
              <Route
                path="/assignments/:id"
                element={<AssignmentDetail />}
              />
              <Route
                path="/assesments/assignments/:id"
                element={<StudentAssignmentDetail />}
              />
              <Route
                path="/assignment/edit-assignments/:id"
                element={<EditAssignment />}
              />
              <Route
                path="/assignment/submission/:id"
                element={<AssignmentSubmission />}
              />
              <Route path="/class-activities/subjects" element={<Subjects />} />
              <Route path="/mysubjects" element={<EmployeeSubjects />} />
              <Route
                path="/class-activities/subjects/:id"
                element={<SubjectDetails />}
              />
              <Route
                path="/subject/:id"
                element={<EmployerSubject />}
              />
              <Route
                path="/assignment/create-assignment"
                element={<AdminCreateAssignent />}
              />
              <Route
                path="/my-assignments/create-assignment"
                element={<AdminCreateAssignent />}
              />
              <Route
                path="/class-activities/syllabus"
                element={<StudentSyllabus />}
              />
              <Route
                path="/configuration"
                element={<ConfigPage />}
              />
              <Route path="/assesments/student-examination" element={<StudentExam />} />
              <Route path="/student-examination/:id" element={<StudentEnrolExam />} />
              <Route path="/student-test/:id" element={<EnrolTest />} />
              <Route path="/student-assignment/:id" element={<StudentEnrolAssignment />} />
              <Route path="/assesments/student-test" element={<StudentTest />} />
              <Route path="/assesments/student-test-result" element={<StudentTestResult />} />
              <Route
                path="/class-activities/syllabus/:id"
                element={<SharedSyllabusList />}
              />
              <Route
                path="/class-activities/syllabus/:subjectId/:syllabusId"
                element={<SyllabusDetails />}
              />
              {/* <Route path="/subjects/assignment/:id" element={<Assignments />} /> */}
              {/* The Route Below is used to navigate to Subject (Mathematics, e.t.c) */}
              <Route path="/onboarding" element={<WelcomeToShelf />} />
              <Route path="/onboarding-page" element={<OnboardingGuide />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/settings/addrole" element={<RolesandPermissions />} />
              <Route path="/settings/updaterole/:id" element={<UpdateRole />} />
              <Route path="/internal-server-error" element={<InternalServer />} />
            </Route>
            {/* Student Applications Login */}
            <Route path="/auth/applicant" element={<ApplicantLogin />} />
            <Route
              path="/student-application"
              element={<StudentApplication />}
            />
            <Route path="/enrolment-preview/:id" element={<Enrolmentpreview />} />
            <Route path="/enrolments/applications/:id" element={<ApplicationDetails />} />
            <Route path="/enrolments/edit/:id" element={<EditEnrolment />} />
            <Route path="/school-examination/exam-timetable" element={<ExamPeriod />} />
            <Route
              path="/entrance-examination/:id"
              element={<EntranceExamination />}
            />
            <Route path="/payment/view-invoice/:id" element={<PreviewPayInvoice />} />
            <Route path="/subscription/invoice/:id" element={<SubscriptionInvoice />} />
            <Route
              path="/guardian/attendace"
              element={<GuardianAttendance />}
            />
            <Route
              path="/guardian/timetable"
              element={<GuardianTimetable />}
            />
            <Route
              path="/guardian/Subject"
              element={<GuardianSubject />}
            />
            <Route
              path="/guardian/assignments"
              element={<GuardiaAssignment />}
            />

            <Route
              path="/guardian/student/grades"
              element={<GuardianAssessments />}
            />
            <Route
              path="/guardian/notice-board"
              element={<GuardianNotification />}
            />
            <Route
              path="/guardian/payment"
              element={<GuardianPayment />}
            />
            <Route path="/guardian/my-invoice/:id" element={<GuardianPreview />} />
            <Route path="/guardian/transaction/:id" element={<TransactionDetails />} />
            <Route
              path="/guardian/transaction"
              element={<GuardianReceipt />}
            />
            {/* Messaging */}
            <Route path="/messaging/subcription" element={<EmailSubscription />} />
            <Route path="/messaging/subcriber" element={<EmailSubscriber />} />
            <Route path="/messaging/subscriberdetails/:id" element={<SubscriberDetails />} />
            <Route path="/messaging/bulkmails" element={<BulkEmail />} />
            <Route path="/messaging/template" element={<EmailTemplate />} />
            <Route path="/messaging/sendemails" element={<SendBulkEmail />} />
            <Route path="/messaging/mailing-settings" element={<MailingSettings />} />

            <Route path="/ca-result-details/:id" element={<CAResultDetail />} />
            <Route path="/exam-result-details/:id" element={<ExaminationResultDetail />} />
            <Route path="/assignment-result-details/:id" element={<AssignmentResultDetail />} />

            <Route path="/enrol/:id" element={<StudentEnrol />} />
            <Route path="/payment-response" element={<Success />} />
            <Route path="/payment-invoice-response" element={<PaymentSuccess />} />
            <Route path="/payment-invoice-declined" element={<PaymentDeclined />} />
            <Route
              path="/payment/view-invoice/:id"
              element={<PreviewPayInvoice />}
            />
            <Route path="payfailed=" element={<Failed />} />

            <Route path="/auth/login" element={<Login />} />
            <Route path="/referral/generatelink" element={<GenerateLink />} />
            <Route path="/referral/success" element={<ReferralSuccess />} />
            <Route path="/auth/referrer" element={<ReferralAuth />} />
            <Route path="/referrer/dashboard" element={<ReferralDashboard />} />
            <Route path="/auth/selectaccount" element={<AccountSelect />} />
            <Route path="/auth/signup" element={<Signup />} />
            <Route path="/auth/user-signup/:id" element={<UserSignUp />} />
            <Route path="/auth/student-signup/:id" element={<StudentSignUp />} />
            <Route path="/not-allowed" element={<Permission />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/auth/verify/:id" element={<AuthVerification />} />
            <Route path="/auth/reset/:id" element={<ResetPassword />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </BrowserRouter>
        <ToastContainer />
      </ThemeProvider>
    </div>
  );
};

export default App;
